@if(resolvedData){

<mat-card>
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20" style="align-items: flex-start;">
            <div class="left">
                <mat-card-title class="">
                    <div class="g-just-flex flex-start flex-wrap gap-15 align-items-center">
                        <div class="rounded-image">
                            <img style="border-radius: 50%;" width="100" height="100" [src]="getPatientPhotoUrl()"
                                alt="Patient photo">
                        </div>

                        <div style="flex-direction: column; align-items: start;" class="short-details
                                        g-just-flex flex-column gap-12 
                                        ">
                            <div class="top  g-just-flex gap-2 justify-content-start ">
                                <span style="text-align: left;">
                                    <span
                                    class="g-just-flex gap-12 align-items-start flex-column">
                                    {{resolvedData.name?.[0]?.family |
                                    titlecase}}
                                    {{resolvedData.name?.[0]?.given?.[0] |
                                    titlecase}}
                                    </span>
                                    
                                    <span
                                    class="subtitle-text-color-2 small-subtitle"
                                    style="margin-top: -35px;"
                                    >{{getPatientHospitalId(resolvedData)}}</span>
                                    </span><span
                                    ></span><span></span>
                            </div>
                            <div class="bottom  g-just-flex gap-12 justify-content-start"
                                style="font-size: 16px;flex-wrap:wrap">
                                <div class="g-just-flex gap-8">


                                    <mat-icon style="font-size: 16px; width: 16px; height: 16px;
                                                       
                                                        ">person</mat-icon>

                                    <span>{{resolvedData.gender | titlecase}}</span>

                                </div> |
                                <div class="g-just-flex gap-8">


                                    <mat-icon style="font-size: 16px; width: 16px; height: 16px;
                                                       
                                                        ">cake</mat-icon>

                                    <span>{{resolvedData.birthDate | age}}</span>

                                </div> |
                                <div class="g-just-flex gap-8">


                                    <mat-icon style="font-size: 16px; width: 16px; height: 16px;
                                                       
                                                        ">location_on</mat-icon>
                                    @if (resolvedData.address?.[0]?.city || resolvedData.address?.[0]?.state ||
                                    resolvedData.address?.[0]?.country) {
                                    <span>
                                        {{resolvedData.address?.[0]?.city}},
                                        {{resolvedData.address?.[0]?.state}},
                                        {{resolvedData.address?.[0]?.country}}

                                    </span>
                                    }@else {
                                    <span>N / A</span>
                                    }

                                </div>



                                <span></span>
                            </div>
                            <div class="bottom-last  g-just-flex gap-12 justify-content-start" style="font-size: 16px;">
                                <div class="g-just-flex gap-8">


                                    <mat-icon style="font-size: 16px; width: 16px; height: 16px;
                                                       
                                                        ">phone</mat-icon>

                                    <span>
                                        @if(resolvedData.telecom?.[0]?.value){
                                        <a style="text-decoration: none !important;"
                                            href="tel:{{resolvedData.telecom?.[0]?.value}}">
                                            {{resolvedData.telecom?.[0]?.value}}
                                        </a>
                                        }@else {
                                        <span>N / A</span>
                                        }
                                    </span>
                                </div>




                                <span></span>
                            </div>
                        </div>
                    </div>
                </mat-card-title>
            </div>
            <div class="right gap-10 g-just-flex">

                <!-- <a mat-button class="">
                    <mat-icon>edit</mat-icon>
                    Edit
                </a> -->


            </div>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="to-do-tasks my-20">
            @if((auth.user | async)?.role == 'doctor' || (auth.user | async)?.role == 'nurse') {
            <mat-card>
                <mat-card-header>
                    <mat-card-title>
                        Sugested Tasks
                    </mat-card-title>
                    <mat-card-subtitle>
                        The following are some of the recommended things which you can do for this patient
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <div class="py-15">

                        <div class="suggested-tasks">
                            <div class="suggested-tasks-wrapper">
                                @if((auth.user | async)?.role === 'doctor' ){
                                <div class="suggested-task" (click)="encounterService.addEncounter(patientId)"
                                    [ngClass]="{success: (encounterService.stateService.currentEncounter | async)?.status === 'in-progress' ||
                                 (encounterService.stateService.currentEncounter | async)?.status === 'finished' ||
                                    (encounterService.stateService.currentEncounter | async)?.status === 'planned'    
                                 }">


                                    <div class="rounded-icon-wrapper me-15">
                                        <mat-icon>event</mat-icon>

                                    </div>

                                    <div class="me-12 panel-description" matTooltip=" An encounter is an engagement with the patient either at the outpatient
                                            ward on in the admission ward">
                                        Add an Encounter
                                    </div>
                                    <mat-icon>chevron_right</mat-icon>


                                    <div class="after-div">
                                        <mat-icon>check</mat-icon>
                                    </div>

                                </div>
                                }
                                <div class="suggested-task"
                                    [ngClass]="{success: (hasActiveEncounterObservation$ | async)}">


                                    <div class="rounded-icon-wrapper me-15">
                                        <mat-icon>insights

                                        </mat-icon>

                                    </div>
                                    <div (click)="encounterService.addObservation(patientId)"
                                        class="me-12 panel-description"
                                        matTooltip=" An observation can be a physical exam findings or lab results">
                                        Add an Observation
                                    </div>
                                    <mat-icon>chevron_right</mat-icon>


                                    <div class="after-div">
                                        <mat-icon>check</mat-icon>
                                    </div>

                                </div>
                                <div class="suggested-task"
                                    [ngClass]="{success: (hasActiveEncounterMedicationRequest$ | async)}">


                                    <div class="rounded-icon-wrapper me-15">
                                        <mat-icon>medication

                                        </mat-icon>

                                    </div>
                                    <div (click)="encounterService.addMedicationRequest(patientId)"
                                        class="me-12 panel-description"
                                        matTooltip="Prescribe a drug / medication to the patient">
                                        Add a Medication
                                    </div>
                                    <mat-icon>chevron_right</mat-icon>


                                    <div class="after-div">
                                        <mat-icon>check</mat-icon>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>
                </mat-card-content>
            </mat-card>
            }
        </div>
        <div class="tables g-just-flex flex-wrap justify-content-start gap-30 my-30 ">
            <div class="col-65-35 g-just-flex gap-30 flex-wrap" style="    width: 100%;
    max-width: 100%;
    justify-content: FLEX-START;
    align-items: flex-start;">
                <div class="sixty-five g-just-flex gap-30 flex-column justify-content-start"
                    style="flex: 1 1 59%; min-width: 280px; align-items: flex-start;">

                    <mat-card style="width: 100%; max-width: 100%;">
                        <mat-card-header>
                            <div class="g-just-flex flex-between w-100 flex-wrap gap-30">
                                <div class="left">
                                    <mat-card-title class="">
                                        Recent Encounters
                                    </mat-card-title>
                                    <!-- <mat-card-subtitle>
                                                        Find, search and add patients registration data
                                                    </mat-card-subtitle> -->
                                </div>
                                <div class="right gap-10 g-just-flex">
                                    @if((auth.user | async)?.role === 'doctor' ){

                                    <a (click)="encounterService.addEncounter(patientId)" mat-flat-button extended
                                        class="secondary-button small-button" [disabled]="
                                        (encounterService.stateService.currentEncounter | async)?.status &&
                                    ((encounterService.stateService.currentEncounter | async)?.status == 'in-progress' ||
                                        (encounterService.stateService.currentEncounter | async)?.status == 'planned')
                                        ">
                                        <mat-icon>add</mat-icon>
                                        Add Encounter
                                    </a>
                                    <!-- } @else {
                                    <a (click)="encounterService.addTask(patientId)" mat-flat-button extended
                                        class="secondary-button small-button">
                                        <mat-icon>checklist</mat-icon>
                                        Tasks
                                    </a>
                                    } -->
                                    }
                                     <a mat-flat-button [routerLink]="['/app/patients/', patientId, 'patient-encounters']"
                                         routerLinkActive="router-link-active">
                                         See All <mat-icon>chevron_right</mat-icon>
                                     </a>


                                </div>
                            </div>
                        </mat-card-header>

                        <mat-card-content class="my-12">
                            <mat-divider></mat-divider>
                            @if(encounterDataSource && encounterDataSource.length > 0){
                            <table mat-table [dataSource]="encTabDataSource" class="mat-elevation-z8 demo-table"
                                style="width: 100%;">
                                <!-- Position Column -->
                                <ng-container matColumnDef="date">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="date"
                                        sortActionDescription="Sort by date">
                                        Date
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{
                                        element.period?.start?(element.period.start |
                                        date: 'shortDate') : 'N/A'}}

                                    </td>
                                </ng-container>

                                <!--Status Column-->
                                <ng-container matColumnDef="status">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="status"
                                        sortActionDescription="Sort by status">
                                        Status
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="status" title="{{element.status}}">
                                        <div appChips [appChips]="element.status" [fontSize]="'14px'"
                                            title="{{element.status}}" [showText]="true">

                                        </div>

                                    </td>
                                </ng-container>

                                <!-- Name Column -->
                                <ng-container matColumnDef="reason">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                        sortActionDescription="Sort by reason">
                                        Presented Symptoms
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        @if(element.presentedSymptoms){
                                        @for(elem of element.presentedSymptoms.split(","); track $index){
                                        <div class="top mb-4">{{elem.trim()}}</div>

                                        }
                                        }@else{
                                        N / A
                                        }

                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="diagnosis">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                        sortActionDescription="Sort by diagnosis">
                                        Diagnosis (Confirmed)
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        @if(element.diagnosis){
                                        @for(elem of element.diagnosis.split("$#$"); track $index){
                                        @if(elem.trim()){
                                        <div class="top mb-4"
                                        [title]="elem.trim()"
                                        >{{elem.trim()}}</div>
                                        }
                                        }
                                        }@else{
                                        N / A
                                        }
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="doctor">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                        sortActionDescription="Sort by doctor">
                                        Physician
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{element.participant?.[0]?.['individual']?.['display']
                                        || element.participant?.[0]?.['individual']?.['reference'] || 'N / A'
                                        }}
                                    </td>
                                </ng-container>





                                <tr mat-header-row *matHeaderRowDef="summaryTables.encounter.displayedColumns"
                                    matHeaderRowDefSticky="true">
                                </tr>
                                <tr mat-row *matRowDef="let row; columns: summaryTables.encounter.displayedColumns;">
                                </tr>
                            </table>
                            }@else {
                            <app-empty-state [icon]="'PEOPLE'" [iconSet]="'material-symbols-outlined'"
                                title="No Encounter Yet"
                                subtitle="Recent encounters will be shown here"></app-empty-state>
                            }
                        </mat-card-content>
                    </mat-card>

                    <mat-card style="width: 100%; max-width: 100%;">
                        <mat-card-header>
                            <div class="g-just-flex flex-between w-100 flex-wrap gap-30">
                                <div class="left">
                                    <mat-card-title class="">
                                        Recent Diagnosis

                                    </mat-card-title>
                                    <!-- <mat-card-subtitle>
                                                        Find, search and add patients registration data
                                                    </mat-card-subtitle> -->
                                </div>
                                <div class="right gap-10 g-just-flex">
                                    @if((auth.user | async)?.role === 'doctor' ){
                                    <a (click)="encounterService.addDiagnosisV2()" mat-flat-button extended
                                        class="secondary-button small-button">
                                        <mat-icon>add</mat-icon>
                                        Add Diagnosis
                                    </a>
                                    }
                                    <a mat-flat-button [routerLink]="['/app/patients/', patientId, 'diagnosis']"
                                        routerLinkActive="router-link-active">
                                        See All <mat-icon>chevron_right</mat-icon>
                                    </a>


                                </div>
                            </div>
                        </mat-card-header>
                        @if (filteredConditionDataSource && filteredConditionDataSource.length > 0) {
                        <mat-card-content class="my-12">
                            <mat-divider></mat-divider>

                            <table mat-table matSort [dataSource]="filteredConditionDataSource"
                                class="mat-elevation-z8 demo-table" style="width: 100%;">

                                <ng-container matColumnDef="status">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="status"
                                        sortActionDescription="Sort by status">
                                        Status
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="status" s>
                                        <div [appChips]="element.verificationStatus | codeableConcept2"
                                            [fontSize]="'14px'">

                                        </div>

                                    </td>
                                </ng-container>

                                <!--name - coding.code.display-->
                                <ng-container matColumnDef="code">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="code"
                                        sortActionDescription="Sort by Name">
                                        Name
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{element.code?(element.code |
                                        codeableConcept2 |
                                        titlecase): 'N / A' }}
                                    </td>
                                </ng-container>

                                <!--dateRecorded - recordedDateTime -->
                                <ng-container matColumnDef="recordedDate">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="recordedDate"
                                        sortActionDescription="Sort by Date Recorded">
                                        Date
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{element.recordedDate?(element.recordedDate
                                        | date: 'shortDate'): 'N / A'}}
                                    </td>
                                </ng-container>

                                <!--category - category.coding.display -->
                                <!-- <ng-container matColumnDef="category">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="category"
                                        sortActionDescription="Sort by Category">
                                        Category
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{element.category[0].coding[0].code |
                                        titlecase}}
                                    </td>
                                </ng-container> -->

                                <ng-container matColumnDef="asserter">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="asserter"
                                        sortActionDescription="Sort by Asserter">
                                        Asserter
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        <div appReferenceDisplay="{{element.asserter?.reference || ''}}"
                                            [maxWidth]="'70px'">

                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="severity">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="severity"
                                        sortActionDescription="Sort by Severity">
                                        Severity
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        @if(element.severity){
                                        <span [appEmphasis]="element.severity | codeableConcept2" [fontSize]="'13px'">
                                            {{element.severity | codeableConcept2 | titlecase}}
                                        </span>
                                        } @else {
                                        N / A
                                        }
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="summaryTables.condition.displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: summaryTables.condition.displayedColumns;">
                                </tr>

                            </table>


                        </mat-card-content>
                        }@else {
                        <app-empty-state [icon]="'HOSPITAL'" [iconSet]="'material-symbols-outlined'"
                            title="No Diagnosis Yet" subtitle="Recent diagnosis will be shown here">

                        </app-empty-state>
                        }
                    </mat-card>
                    <mat-card style="width: 100%; max-width: 100%;">
                        <mat-card-header>
                            <div class="g-just-flex flex-between w-100 flex-wrap gap-30 ">
                                <div class="left">
                                    <mat-card-title class="">
                                        Current Medication
                                    </mat-card-title>
                                    <!-- <mat-card-subtitle>
                                                        Find, search and add patients registration data
                                                    </mat-card-subtitle> -->
                                </div>
                                <div class="right gap-10 g-just-flex justify-content-end">


                                    <a mat-flat-button [routerLink]="['/app/patients/', patientId, 'medications']"
                                        routerLinkActive="router-link-active">
                                        See All <mat-icon>chevron_right</mat-icon>
                                    </a>


                                </div>
                            </div>
                        </mat-card-header>

                        <mat-card-content class="my-20">
                            <mat-divider></mat-divider>

                            <div class="red-pill-wrapper gap-20 mt-20 g-just-flex flex-wrap justify-content-start">
                                @for(med of (medicationHistoryDataSource$ | async); track med.id){
                                <div class="red-pills g-just-flex gap-16 py-8">
                                    <div class="position-absolute severity low-criticality">
                                        <mat-icon class="me-8"
                                            style="font-size: 16px; height: 16px; width: 16px;">chevron_right</mat-icon>
                                    </div>
                                    <div class="g-just-flex gap-8" style="flex-direction: row;">
                                        <mat-icon>medication</mat-icon>
                                        <span class="allergy">
                                            <!-- {{med | json}} -->
                                            @if(med.medicationCodeableConcept){
                                            {{med.medicationCodeableConcept |
                                            codeableConcept2}}}@else if(med.medicationReference){
                                            <span [appReferenceDisplay]="med.medicationReference.reference"
                                                [InstantfetchAndRepace]="true">

                                            </span>
                                            }@else{
                                            "N / A"
                                            }</span>
                                    </div>
                                </div>
                                }@empty {
                                <app-empty-state [iconSet]="'material-symbols-outlined'" [icon]="'medication'"
                                    [title]="'No Medications'"
                                    [subtitle]="'Recent medication requests will be shown here'">
                                </app-empty-state>
                                }
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div class="thirty-five g-just-flex gap-30 flex-column"
                    style="flex: 1 1 230px; width: 230px;max-width: 100%; align-items: flex-start;">
                    <mat-card style="width: 100%; max-width: 100%;">
                        <div class="bottom  g-just-flex gap-12 justify-content-start p-15" style="
                                flex-direction: column;
                                align-items: flex-start;
                                font-size: 16px;">
                            <div class="info-group-title high-criticality mb-20" style="padding: 0rem 0.5rem;
                                    border-radius: 2px;
                                    ">
                                Allergies
                            </div>
                            <div class="red-pill-wrapper gap-20 g-just-flex flex-wrap justify-content-start">
                                @for(allergy of (allergyDataSource$ | async); track allergy.id){
                                <div class="red-pills g-just-flex gap-8">
                                    <div class="position-absolute severity"
                                        [ngClass]="allergy.criticality + '-criticality'">
                                        <mat-icon class="me-8">{{allergy.criticality === 'high' ? 'report_problem' :
                                            'trending_down'}}</mat-icon>
                                    </div>
                                    <div class="g-just-flex gap-8" style="flex-direction: row;">
                                        <mat-icon>{{allergy.category?.includes('medication') ? 'medication' :
                                            'fastfood'}}</mat-icon>
                                        <span class="allergy">{{allergy.code | codeableConcept2}}</span>
                                    </div>
                                </div>
                                }@empty {
                                <div class="subtitle-text-color-2">No known allergies.</div>
                                }
                            </div>
                            <span></span>
                        </div>
                    </mat-card>
                    <!-- <mat-card style="width: 100%; max-width: 100%;">
						<mat-card-header>
							<mat-card-subtitle class="g-just-flex gap-12"
								style="display: flex; color: var(--mat-sys-primary);  font-weight: 700;">
								<span class="rounded-icon-wrapper "
									style="background-color: var(--mat-sys-surface-container-lowest);">
									<mat-icon>vaccines</mat-icon>
								</span>
								<span>
									Vaccinations
								</span>
							</mat-card-subtitle>
						</mat-card-header>
						<mat-card-content>
							<div class="mt-15">
								@for(imm of (immunizationDataSource$ | async); track imm.id){
								<div class="g-just-flex gap-20 mb-20 flex-wrap flex-between">
									<div class="field-title g-just-flex gap-12 subtitle-text-color-2">
										<mat-icon
											style="font-size: 16px; width: 16px; height: 16px; color: var(--mat-sys-primary);">
											event_available
										</mat-icon>
										{{imm.vaccineCode | codeableConcept2}}
									</div>
									<div class="field-value" style="text-align: flex-end;">
										{{(imm.occurrenceDateTime | date:'shortDate') || 'N/A'}}
									</div>
								</div>
								}@empty {
								<app-empty-state [iconSet]="'material-symbols-outlined'" [icon]="'vaccines'"
									[title]="'No Vaccinations'" [subtitle]="'Immunization records will be shown here'">
								</app-empty-state>
								}
							</div>
						</mat-card-content>
					</mat-card> -->

                    <mat-card style="width: 100%; max-width: 100%;">
                        <mat-card-header>
                            <mat-card-subtitle class="g-just-flex gap-12"
                                style="display: flex; color: var(--mat-sys-primary);  font-weight: 700;">
                                <span class="rounded-icon-wrapper "
                                    style="background-color: var(--mat-sys-surface-container-lowest);">
                                    <mat-icon>monitor_heart</mat-icon>
                                </span>
                                <span>
                                    Last Checked Vitals
                                </span>
                            </mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="mt-15">
                                @for(eachVital of vitalMapForTemplate; track $index){

                                <div class="g-just-flex gap-20 mb-20 flex-wrap flex-between">
                                    <div class="field-title g-just-flex gap-12 subtitle-text-color-2">
                                        <mat-icon [fontIcon]="eachVital['icon']"
                                            style="font-size: 16px; width: 16px; height: 16px; color: var(--mat-sys-primary);">
                                        </mat-icon>
                                        {{eachVital['key'] | titlecase }}
                                    </div>
                                    <div class="field-value" style="text-align: flex-end;">
                                        {{eachVital['value']}}
                                    </div>
                                </div>
                                }@empty {
                                <app-empty-state [iconSet]="'material-symbols-outlined'" [icon]="'monitor_heart'"
                                    [title]="'No Vitals Yet'"
                                    [subtitle]="' Vitals recorded during the last encounter will be shown here'">
                                </app-empty-state>
                                }
                            </div>
                        </mat-card-content>
                    </mat-card>

                </div>
            </div>
        </div>
    </mat-card-content>



    <mat-card-content class="my-12">
    </mat-card-content>
</mat-card>

<!-- <div (click)="displayForm();">hey</div> -->
}